import { NotificationsListContainer } from '@/components/containers/NotificationsListContainer'
import NotificationsListView from '@/components/views/notifications/NotificationsListView'

const NotificationsPage = () => <NotificationsListContainer View={(props) => <NotificationsListView {...props} />} />

export default NotificationsPage
